import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=8e36abbe&"
import script from "./agreement.vue?vue&type=script&lang=ts&"
export * from "./agreement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports